import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useConfirmGuestInfoOracleMutation } from '../../../../store/reservations/reservationsApi';
import WhiteContainer from '../../../../shared/white-container';
import Button from '../../../../shared/button';

interface IGuestInfoTab {
    data: any;
    id: string;
}

const GuestInfoTab = ({
    data,
    id
}: IGuestInfoTab) => {
    const [allData, setAllData] = useState<any>(data?.guests);
    const [showGuest, setShowGuest] = useState<any>();
    const [confirmGuestInfoOracle, { isLoading: isLoadingGuestInfo }] = useConfirmGuestInfoOracleMutation();

    useEffect(() => {
        setAllData(data?.guests)
    }, [data])

    const escapeHtmlString = (htmlString: any) => {
        return htmlString
            .replace(/"/g, '\\"')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r');
    };

    const onFormatHtml = (text: string) => {
        let htmlText: any
        try {
            htmlText = escapeHtmlString(text);
            htmlText = JSON.parse(`"${htmlText}"`);
        } catch (error) {
            htmlText = text
        }
        // const textFormat = htmlText?.replace(/\n/g, '');
        let parser = new DOMParser();
        let doc = parser.parseFromString(htmlText, "text/html");

        let headers = doc.querySelectorAll("h2");



        headers.forEach((header, index: number) => {
            if (header.textContent?.trim().toLowerCase() === "references") {
                let nextElement = header.nextElementSibling;
                if (nextElement && nextElement.tagName.toLowerCase() === "ul") {
                    let listItems = nextElement.querySelectorAll("li");
                    listItems.forEach((li) => {
                        let text = li.textContent?.trim() || "";
                        let urlMatch = text.match(/https?:\/\/[^\s]+/g); // Extract URLs
                        if (urlMatch) {
                            li.innerHTML = urlMatch.map(url =>
                                `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
                            ).join(", ");
                        }
                    });
                }
            }
        });

        return doc.body.innerHTML.replace(/\n/g, '');
    }

    const onClickConfirmGuest = async (guestId: string) => {
        try {
            const formData = {
                reservationId: data?._id,
                guestProfileId: guestId,
            }
            await confirmGuestInfoOracle(formData).unwrap();
            const formatAllData = (allData && allData?.length > 0) && allData?.find((item: any) => item?.id === guestId)
            setAllData([formatAllData])
        } catch (err) {
            // error
        }
    }

    const onViewGuestDetails = (id: string) => {
        const findIsViewing = showGuest && showGuest?.length > 0 && showGuest?.find((item: any) => item === id)
        if (findIsViewing) {
            const filterOtherViewing = showGuest && showGuest?.length > 0 && showGuest?.filter((item: any) => item !== id)
            setShowGuest(filterOtherViewing || [])
        } else {
            setShowGuest([...showGuest || [], id]?.sort((a, b) => a - b))
        }
    }

    return (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <WhiteContainer containerStyle='!rounded'>
                <div className='mb-8'>
                    <h4 className='text-base md:text-xl mb-4'>Guest Details</h4>
                    <div className='flex flex-row justify-between items-center mb-2  text-sm'>
                        <p className='text-primary-light'>Full Name</p>
                        <p>{data?.firstName} {data?.lastName}</p>
                    </div>
                    <div className='flex flex-row justify-between items-center mb-2 text-sm'>
                        <p className='text-primary-light'>Phone</p>
                        <p>{data?.phoneNumber}</p>
                    </div>
                    <div className='flex flex-row justify-between items-center mb-2 text-sm'>
                        <p className='text-primary-light'>Email</p>
                        <p>{data?.email}</p>
                    </div>
                    {data?.birthDate &&
                        <div className='flex flex-row justify-between items-center mb-2 text-sm'>
                            <p className='text-primary-light'>Birth Date</p>
                            <p>{moment(data?.birthDate)?.format('MMM DD, YYYY')}</p>
                        </div>
                    }
                    <div className='flex flex-row justify-between items-center mb-2 text-sm'>
                        <p className='text-primary-light'>Check-in</p>
                        <p>{moment(data?.checkinDate)?.format('MMM DD, YYYY')}</p>
                    </div>
                    <div className='flex flex-row justify-between items-center mb-2 text-sm'>
                        <p className='text-primary-light'>Check-out</p>
                        <p>{moment(data?.checkoutDate)?.format('MMM DD, YYYY')}</p>
                    </div>
                </div>
                <div className='mb-8'>
                    <h4 className='text-base md:text-xl mb-4'>Guest Status</h4>
                    <div className='flex flex-row justify-between items-center mb-2 text-sm'>
                        <p className='text-primary-light'>Regular Guest</p>
                        <div className='flex items-center mr-1'>
                            <input
                                checked={data?.guestStatus === 'Regular'}
                                id='checkbox-all-1'
                                data-qa={'checkbox'}
                                type='checkbox'
                                className='w-4 h-4 !outline-none text-blue-600 bg-gray-100 border-gray-300 accent-gray-800 rounded focus:accent-gray-800 focus:ring-2 cursor-normal'
                            />
                            <label htmlFor='checkbox-all-1' className='sr-only'>
                            </label>
                        </div>
                    </div>
                    <div className='flex flex-row justify-between items-center mb-2 text-sm'>
                        <p className='text-primary-light'>VIP Guest</p>
                        <div className='flex items-center mr-1'>
                            <input
                                checked={data?.guestStatus === 'VIP'}
                                id='checkbox-all-1'
                                data-qa={'checkbox'}
                                type='checkbox'
                                className='w-4 h-4 !outline-none text-blue-600 bg-gray-100 border-gray-300 accent-gray-800 rounded focus:accent-gray-800 focus:ring-2 cursor-normal'
                            />
                            <label htmlFor='checkbox-all-1' className='sr-only'>
                            </label>
                        </div>
                    </div>

                </div>
            </WhiteContainer>
            <div>
                {allData && (Array.isArray(allData) ? allData?.length > 0 : true) ?
                    <WhiteContainer containerStyle='!rounded !p-3 mb-6 !h-auto'>
                        <div className='flex flex-row items-start mb-6'>
                            <img alt="guests-ai" src={'/assets/shared/guest-ai.svg'} className='object-contain w-[25px] mr-3' />
                            <div>
                                <p className='text-primary-default font-bold text-[16px] mb-1'>Guest Intelligence AI found {Array.isArray(allData) ? allData?.length : 1} results for this customer.</p>
                                {(Array.isArray(allData) && allData?.length > 1) && <p className='text-primary-light'>You can mark which customer matches with the information provided!</p>}
                            </div>
                        </div>
                        <div className='ml-[34px]'>
                            {(Array.isArray(allData) ? allData : [allData])?.map((item: any, idx: number) => {
                                const isViewing = showGuest && showGuest?.length > 0 && showGuest?.find((guest: any) => guest === item?.id)
                                return (
                                    <div key={idx} className='flex flex-row items-center my-2 cursor-pointer' onClick={() => onViewGuestDetails(item?.id)}>
                                        <p className='text-[13px]'>{data?.firstName} {data?.lastName} {(Array.isArray(allData) && allData?.length > 1) ? `(${idx + 1})` : ''}</p>
                                        <img src={'/assets/shared/guest-arrow.svg'} className={'object-contain min-w-[18px] ml-3 mr-3'} />
                                        {isViewing && <p className='text-[#008000] text-[13px]'>Viewing...</p>}
                                    </div>
                                )
                            })}
                        </div>
                    </WhiteContainer>
                    : <WhiteContainer containerStyle='!rounded !p-3 mb-6'>
                        <div className='rounded-[6px] p-3 flex flex-row justify-center items'>
                            <p className='text-primary-light my-10 text-center'>No details found for this Guest</p>
                        </div>
                    </WhiteContainer>
                }
                {(allData && (Array.isArray(allData) ? allData?.length > 0 : true)) &&
                    <>
                        {(Array.isArray(allData) ? allData : [allData])?.filter((item: any) => showGuest?.includes(item.id))?.map((item: any, index: number) => {
                            const position = (allData?.findIndex((data: any) => data.id === item?.id) + 1) || null;
                            return (
                                <WhiteContainer key={index} containerStyle='!rounded !p-3 mb-6 !h-auto'>
                                    <div className='flex flex-row items-center justify-between'>
                                        <p className='ml-5 mr-5'>{data?.firstName} {data?.lastName} {(Array.isArray(allData) && allData?.length > 1) ? `(${position})` : ''}</p>
                                        {(Array.isArray(allData) && allData?.length > 1) &&
                                            <div className='flex flex-row justify-end mb-2'>
                                                <Button
                                                    label={'Customer Match'}
                                                    scndIcon={<img src={'/assets/shared/guest-confirm.svg'} className='object-contain w-[19px] ml-3' />}
                                                    className='btn-primary !bg-[#eaefeb] !text-primary-default !rounded mt-2 min-w-[150px] flex flex-row justify-between items-center'
                                                    onClickButton={() => onClickConfirmGuest(item?.id)}
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: `${onFormatHtml(item?.htmlContent ? item?.htmlContent : item)}` || "" }}
                                        className="pb-10 px-5 py-3 min-h-72 overflow-auto profile text-sm"
                                    ></div>
                                </WhiteContainer>
                            )
                        })}
                    </>

                }
            </div>
        </div>
    )
}
export default GuestInfoTab;